import { HttpClient, HttpResponse } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { SelectItem } from "primeng/api";
import { Observable } from "rxjs";
import { debounce, map } from "rxjs/operators";
import { AutomapperService } from "../../../../core/automapper/automapper.service";
import { BASE_API_URL } from "../../../../core/environment.tokens";
import { DataSet } from "../../../../shared/kpi/model/data-set.model";
import { ListItem } from "../../../../shared/list/list-item";
import { BulkDocumentApprovalRequest } from "./bulk-document-approval-request";
import { BulkDocumentApprovalValidateResponse } from "./bulk-document-approval-validate-response";
import { DocumentApprovalSearchResponse } from "./document-approval-search-results";
import { DocumentApprovalSearch } from "./document-approval-search.model";
@Injectable({
  providedIn: "root",
})
export class ApprovalCenterService {

  constructor(
    @Inject(BASE_API_URL) private readonly baseApiUrl: string,
    private http: HttpClient,
    private automapper: AutomapperService
  ) { }

  getApprovaStats(): Observable<ListItem[]> {
    const url = `${this.baseApiUrl}project/getprojectstatsasync`;

    return this.http.get(url).pipe(
      map(this.automapper.curryMany("default", "ListItem"))
    );
  }

  getDocumentApproval(search: DocumentApprovalSearch): Observable<DocumentApprovalSearchResponse[]> {
    const url = `${this.baseApiUrl}document/approval/search`;

    return this.http.post(url, search).pipe(
      map(this.automapper.curryMany("default", "DocumentApprovalSearchResponse"))
    );

  }

  setDocumentApprovalState(documentApprovalId: number, documentApprovalState: number, documentTypeId: number): Observable<object> {
    const url = `${this.baseApiUrl}document/approval/updatestate?documentApprovalId=${documentApprovalId}
                &documentApprovalStateId=${documentApprovalState}&documentTypeId=${documentTypeId}`;

    return this.http.post(url, null, {}) as Observable<object>;
  }

  setMultipleDocumentApprovalUpdateState(bulkDocumentApprovalRequestModel: BulkDocumentApprovalRequest): Observable<BulkDocumentApprovalValidateResponse[]> {
    const url = `${this.baseApiUrl}document/approval/updatestate/multiple`;

    return this.http.post(url, bulkDocumentApprovalRequestModel, {}) as Observable<BulkDocumentApprovalValidateResponse[]>;
  }

  getDocumentApprovalStats(): Observable<ListItem[]> {
    const url = `${this.baseApiUrl}document/approval/stats`;

    return this.http.get(url).pipe(
      map(this.automapper.curryMany("default", "ListItem"))
    );
  }

}
